export default "__VITE_ASSET__sUz34eGB__"